// dependencies
import { Map } from "immutable";

// selectors
import { getUserIsAdmin } from "../../../../selectors/app";
import { getQueryParam } from "../../../../selectors/navigation";

export const selectUserHasAdminDigest = (state) => getUserIsAdmin(state);
export const selectLocalState = (state) => state.page.getIn(["userSettingsNotifications"], Map());
export const selectIsInitialized = (state) => selectLocalState(state).get("initialized", false);
export const selectRequestingNotifications = (state) => selectLocalState(state).get("awaitingRequests", Map());

export const selectActiveSection = (state, notSetValue = null) => {
	let activeSection = getQueryParam(state, "activeSection");

	if (["asap-daily", "digest", "admin-digest"].indexOf(activeSection) === -1) {
		activeSection = notSetValue;
	}

	return activeSection;
};
